module.exports = __webpack_public_path__ + "img/maneken_pos_1.43d9fe2b.png";